// @flow
import React, {PureComponent} from 'react'

import Modal from 'react-modal'
import styles from './Modal.module.scss'
import Loading from 'modules/Common/components/Loading'

export type Props = {
  isShow: boolean,
  handleClose: () => void,
  afterOpen: () => void,
  renderHeader: () => any,
  renderBody: () => any,
  isLoading?: boolean
};

export class AdminModal extends PureComponent<Props, void> {
  render() {
    return (
      <Modal
        isOpen={this.props.isShow}
        ariaHideApp={false}
        onAfterOpen={this.props.afterOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={this.props.handleClose}
        contentLabel='Modal'
        className={styles['modal-base']}
        overlayClassName={styles['modal-overlay-base']}
      >
        <div className={styles.modal}>
          <div className={styles['modal-header']}>{this.props.renderHeader()}</div>
          <div className={styles['modal-body']}>
            {this.props.isLoading ? (
              <Loading spin='circle' color='#768498' hideTitle={false} />
            ) : (
              this.props.renderBody()
            )}
          </div>
        </div>
      </Modal>
    )
  }
}

export default AdminModal
